import { useVirtualizer as re } from "./index324.js";
import { defineComponent as j, ref as E, computed as b, watch as H, provide as oe, onMounted as X, h as W, Fragment as se, watchEffect as Y, inject as ae, onUnmounted as ve, nextTick as N, toRaw as k, reactive as de, cloneVNode as pe } from "vue";
import { useControllable as fe } from "./index325.js";
import { useFrameDebounce as ce } from "./index326.js";
import { useId as J } from "./index327.js";
import { useOutsideClick as be } from "./index328.js";
import { useResolveButtonType as me } from "./index329.js";
import { useTrackedPointer as xe } from "./index330.js";
import { useTreeWalker as ge } from "./index331.js";
import { Hidden as Oe, Features as Re } from "./index332.js";
import { useOpenClosedProvider as Se, State as G, useOpenClosed as Ie } from "./index333.js";
import { Keys as A } from "./index334.js";
import { MouseButton as ye } from "./index335.js";
import { history as ee } from "./index336.js";
import { Focus as $, calculateActiveIndex as te } from "./index337.js";
import { disposables as le } from "./index338.js";
import { dom as m } from "./index339.js";
import { sortByDomNode as Ce } from "./index340.js";
import { objectToFormEntries as he } from "./index341.js";
import { match as _ } from "./index342.js";
import { getOwnerDocument as Te } from "./index343.js";
import { isMobile as $e } from "./index344.js";
import { compact as Pe, render as q, omit as Z, Features as Q } from "./index345.js";
function Ve(t, h) {
  return t === h;
}
var we = ((t) => (t[t.Open = 0] = "Open", t[t.Closed = 1] = "Closed", t))(we || {}), Ee = ((t) => (t[t.Single = 0] = "Single", t[t.Multi = 1] = "Multi", t))(Ee || {}), Ae = ((t) => (t[t.Pointer = 0] = "Pointer", t[t.Focus = 1] = "Focus", t[t.Other = 2] = "Other", t))(Ae || {});
let ue = Symbol("ComboboxContext");
function L(t) {
  let h = ae(ue, null);
  if (h === null) {
    let c = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(c, L), c;
  }
  return h;
}
let ne = Symbol("VirtualContext"), Fe = j({ name: "VirtualProvider", setup(t, { slots: h }) {
  let c = L("VirtualProvider"), P = b(() => {
    let e = m(c.optionsRef);
    if (!e) return { start: 0, end: 0 };
    let O = window.getComputedStyle(e);
    return { start: parseFloat(O.paddingBlockStart || O.paddingTop), end: parseFloat(O.paddingBlockEnd || O.paddingBottom) };
  }), o = re(b(() => ({ scrollPaddingStart: P.value.start, scrollPaddingEnd: P.value.end, count: c.virtual.value.options.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return m(c.optionsRef);
  }, overscan: 12 }))), S = b(() => {
    var e;
    return (e = c.virtual.value) == null ? void 0 : e.options;
  }), i = E(0);
  return H([S], () => {
    i.value += 1;
  }), oe(ne, c.virtual.value ? o : null), () => [W("div", { style: { position: "relative", width: "100%", height: `${o.value.getTotalSize()}px` }, ref: (e) => {
    if (e) {
      if (typeof process < "u" && process.env.JEST_WORKER_ID !== void 0 || c.activationTrigger.value === 0) return;
      c.activeOptionIndex.value !== null && c.virtual.value.options.length > c.activeOptionIndex.value && o.value.scrollToIndex(c.activeOptionIndex.value);
    }
  } }, o.value.getVirtualItems().map((e) => pe(h.default({ option: c.virtual.value.options[e.index], open: c.comboboxState.value === 0 })[0], { key: `${i.value}-${e.index}`, "data-index": e.index, "aria-setsize": c.virtual.value.options.length, "aria-posinset": e.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${e.start}px)`, overflowAnchor: "none" } })))];
} }), ot = j({ name: "Combobox", emits: { "update:modelValue": (t) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], nullable: !0, default: null }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, nullable: { type: Boolean, default: !1 }, multiple: { type: [Boolean], default: !1 }, immediate: { type: [Boolean], default: !1 }, virtual: { type: Object, default: null } }, inheritAttrs: !1, setup(t, { slots: h, attrs: c, emit: P }) {
  let o = E(1), S = E(null), i = E(null), e = E(null), O = E(null), d = E({ static: !1, hold: !1 }), s = E([]), r = E(null), T = E(2), w = E(!1);
  function V(l = (u) => u) {
    let u = r.value !== null ? s.value[r.value] : null, v = l(s.value.slice()), f = v.length > 0 && v[0].dataRef.order.value !== null ? v.sort((C, D) => C.dataRef.order.value - D.dataRef.order.value) : Ce(v, (C) => m(C.dataRef.domRef)), y = u ? f.indexOf(u) : null;
    return y === -1 && (y = null), { options: f, activeOptionIndex: y };
  }
  let B = b(() => t.multiple ? 1 : 0), K = b(() => t.nullable), [M, p] = fe(b(() => t.modelValue), (l) => P("update:modelValue", l), b(() => t.defaultValue)), I = b(() => M.value === void 0 ? _(B.value, { 1: [], 0: void 0 }) : M.value), F = null, n = null;
  function g(l) {
    return _(B.value, { 0() {
      return p?.(l);
    }, 1: () => {
      let u = k(a.value.value).slice(), v = k(l), f = u.findIndex((y) => a.compare(v, k(y)));
      return f === -1 ? u.push(v) : u.splice(f, 1), p?.(u);
    } });
  }
  let R = b(() => {
  });
  H([R], ([l], [u]) => {
    if (a.virtual.value && l && u && r.value !== null) {
      let v = l.indexOf(u[r.value]);
      v !== -1 ? r.value = v : r.value = null;
    }
  });
  let a = { comboboxState: o, value: I, mode: B, compare(l, u) {
    if (typeof t.by == "string") {
      let v = t.by;
      return l?.[v] === u?.[v];
    }
    return t.by === null ? Ve(l, u) : t.by(l, u);
  }, calculateIndex(l) {
    return a.virtual.value ? t.by === null ? a.virtual.value.options.indexOf(l) : a.virtual.value.options.findIndex((u) => a.compare(u, l)) : s.value.findIndex((u) => a.compare(u.dataRef.value, l));
  }, defaultValue: b(() => t.defaultValue), nullable: K, immediate: b(() => !1), virtual: b(() => null), inputRef: i, labelRef: S, buttonRef: e, optionsRef: O, disabled: b(() => t.disabled), options: s, change(l) {
    p(l);
  }, activeOptionIndex: b(() => {
    if (w.value && r.value === null && (a.virtual.value ? a.virtual.value.options.length > 0 : s.value.length > 0)) {
      if (a.virtual.value) {
        let u = a.virtual.value.options.findIndex((v) => {
          var f;
          return !((f = a.virtual.value) != null && f.disabled(v));
        });
        if (u !== -1) return u;
      }
      let l = s.value.findIndex((u) => !u.dataRef.disabled);
      if (l !== -1) return l;
    }
    return r.value;
  }), activationTrigger: T, optionsPropsRef: d, closeCombobox() {
    w.value = !1, !t.disabled && o.value !== 1 && (o.value = 1, r.value = null);
  }, openCombobox() {
    if (w.value = !0, !t.disabled && o.value !== 0) {
      if (a.value.value) {
        let l = a.calculateIndex(a.value.value);
        l !== -1 && (r.value = l);
      }
      o.value = 0;
    }
  }, setActivationTrigger(l) {
    T.value = l;
  }, goToOption(l, u, v) {
    w.value = !1, F !== null && cancelAnimationFrame(F), F = requestAnimationFrame(() => {
      if (t.disabled || O.value && !d.value.static && o.value === 1) return;
      if (a.virtual.value) {
        r.value = l === $.Specific ? u : te({ focus: l }, { resolveItems: () => a.virtual.value.options, resolveActiveIndex: () => {
          var C, D;
          return (D = (C = a.activeOptionIndex.value) != null ? C : a.virtual.value.options.findIndex((U) => {
            var z;
            return !((z = a.virtual.value) != null && z.disabled(U));
          })) != null ? D : null;
        }, resolveDisabled: (C) => a.virtual.value.disabled(C), resolveId() {
          throw new Error("Function not implemented.");
        } }), T.value = v ?? 2;
        return;
      }
      let f = V();
      if (f.activeOptionIndex === null) {
        let C = f.options.findIndex((D) => !D.dataRef.disabled);
        C !== -1 && (f.activeOptionIndex = C);
      }
      let y = l === $.Specific ? u : te({ focus: l }, { resolveItems: () => f.options, resolveActiveIndex: () => f.activeOptionIndex, resolveId: (C) => C.id, resolveDisabled: (C) => C.dataRef.disabled });
      r.value = y, T.value = v ?? 2, s.value = f.options;
    });
  }, selectOption(l) {
    let u = s.value.find((f) => f.id === l);
    if (!u) return;
    let { dataRef: v } = u;
    g(v.value);
  }, selectActiveOption() {
    if (a.activeOptionIndex.value !== null) {
      if (a.virtual.value) g(a.virtual.value.options[a.activeOptionIndex.value]);
      else {
        let { dataRef: l } = s.value[a.activeOptionIndex.value];
        g(l.value);
      }
      a.goToOption($.Specific, a.activeOptionIndex.value);
    }
  }, registerOption(l, u) {
    let v = de({ id: l, dataRef: u });
    if (a.virtual.value) {
      s.value.push(v);
      return;
    }
    n && cancelAnimationFrame(n);
    let f = V((y) => (y.push(v), y));
    r.value === null && a.isSelected(u.value.value) && (f.activeOptionIndex = f.options.indexOf(v)), s.value = f.options, r.value = f.activeOptionIndex, T.value = 2, f.options.some((y) => !m(y.dataRef.domRef)) && (n = requestAnimationFrame(() => {
      let y = V();
      s.value = y.options, r.value = y.activeOptionIndex;
    }));
  }, unregisterOption(l, u) {
    if (F !== null && cancelAnimationFrame(F), u && (w.value = !0), a.virtual.value) {
      s.value = s.value.filter((f) => f.id !== l);
      return;
    }
    let v = V((f) => {
      let y = f.findIndex((C) => C.id === l);
      return y !== -1 && f.splice(y, 1), f;
    });
    s.value = v.options, r.value = v.activeOptionIndex, T.value = 2;
  }, isSelected(l) {
    return _(B.value, { 0: () => a.compare(k(a.value.value), k(l)), 1: () => k(a.value.value).some((u) => a.compare(k(u), k(l))) });
  }, isActive(l) {
    return r.value === a.calculateIndex(l);
  } };
  be([i, e, O], () => a.closeCombobox(), b(() => o.value === 0)), oe(ue, a), Se(b(() => _(o.value, { 0: G.Open, 1: G.Closed })));
  let x = b(() => {
    var l;
    return (l = m(i)) == null ? void 0 : l.closest("form");
  });
  return X(() => {
    H([x], () => {
      if (!x.value || t.defaultValue === void 0) return;
      function l() {
        a.change(t.defaultValue);
      }
      return x.value.addEventListener("reset", l), () => {
        var u;
        (u = x.value) == null || u.removeEventListener("reset", l);
      };
    }, { immediate: !0 });
  }), () => {
    var l, u, v;
    let { name: f, disabled: y, form: C, ...D } = t, U = { open: o.value === 0, disabled: y, activeIndex: a.activeOptionIndex.value, activeOption: a.activeOptionIndex.value === null ? null : a.virtual.value ? a.virtual.value.options[(l = a.activeOptionIndex.value) != null ? l : 0] : (v = (u = a.options.value[a.activeOptionIndex.value]) == null ? void 0 : u.dataRef.value) != null ? v : null, value: I.value };
    return W(se, [...f != null && I.value != null ? he({ [f]: I.value }).map(([z, ie]) => W(Oe, Pe({ features: Re.Hidden, key: z, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: C, disabled: y, name: z, value: ie }))) : [], q({ theirProps: { ...c, ...Z(D, ["by", "defaultValue", "immediate", "modelValue", "multiple", "nullable", "onUpdate:modelValue", "virtual"]) }, ourProps: {}, slot: U, slots: h, attrs: c, name: "Combobox" })]);
  };
} });
j({ name: "ComboboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(t, { attrs: h, slots: c }) {
  var P;
  let o = (P = t.id) != null ? P : `headlessui-combobox-label-${J()}`, S = L("ComboboxLabel");
  function i() {
    var e;
    (e = m(S.inputRef)) == null || e.focus({ preventScroll: !0 });
  }
  return () => {
    let e = { open: S.comboboxState.value === 0, disabled: S.disabled.value }, { ...O } = t, d = { id: o, ref: S.labelRef, onClick: i };
    return q({ ourProps: d, theirProps: O, slot: e, attrs: h, slots: c, name: "ComboboxLabel" });
  };
} });
let at = j({ name: "ComboboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(t, { attrs: h, slots: c, expose: P }) {
  var o;
  let S = (o = t.id) != null ? o : `headlessui-combobox-button-${J()}`, i = L("ComboboxButton");
  P({ el: i.buttonRef, $el: i.buttonRef });
  function e(s) {
    i.disabled.value || (i.comboboxState.value === 0 ? i.closeCombobox() : (s.preventDefault(), i.openCombobox()), N(() => {
      var r;
      return (r = m(i.inputRef)) == null ? void 0 : r.focus({ preventScroll: !0 });
    }));
  }
  function O(s) {
    switch (s.key) {
      case A.ArrowDown:
        s.preventDefault(), s.stopPropagation(), i.comboboxState.value === 1 && i.openCombobox(), N(() => {
          var r;
          return (r = i.inputRef.value) == null ? void 0 : r.focus({ preventScroll: !0 });
        });
        return;
      case A.ArrowUp:
        s.preventDefault(), s.stopPropagation(), i.comboboxState.value === 1 && (i.openCombobox(), N(() => {
          i.value.value || i.goToOption($.Last);
        })), N(() => {
          var r;
          return (r = i.inputRef.value) == null ? void 0 : r.focus({ preventScroll: !0 });
        });
        return;
      case A.Escape:
        if (i.comboboxState.value !== 0) return;
        s.preventDefault(), i.optionsRef.value && !i.optionsPropsRef.value.static && s.stopPropagation(), i.closeCombobox(), N(() => {
          var r;
          return (r = i.inputRef.value) == null ? void 0 : r.focus({ preventScroll: !0 });
        });
        return;
    }
  }
  let d = me(b(() => ({ as: t.as, type: h.type })), i.buttonRef);
  return () => {
    var s, r;
    let T = { open: i.comboboxState.value === 0, disabled: i.disabled.value, value: i.value.value }, { ...w } = t, V = { ref: i.buttonRef, id: S, type: d.value, tabindex: "-1", "aria-haspopup": "listbox", "aria-controls": (s = m(i.optionsRef)) == null ? void 0 : s.id, "aria-expanded": i.comboboxState.value === 0, "aria-labelledby": i.labelRef.value ? [(r = m(i.labelRef)) == null ? void 0 : r.id, S].join(" ") : void 0, disabled: i.disabled.value === !0 ? !0 : void 0, onKeydown: O, onClick: e };
    return q({ ourProps: V, theirProps: w, slot: T, attrs: h, slots: c, name: "ComboboxButton" });
  };
} }), ut = j({ name: "ComboboxInput", props: { as: { type: [Object, String], default: "input" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, displayValue: { type: Function }, defaultValue: { type: String, default: void 0 }, id: { type: String, default: null } }, emits: { change: (t) => !0 }, setup(t, { emit: h, attrs: c, slots: P, expose: o }) {
  var S;
  let i = (S = t.id) != null ? S : `headlessui-combobox-input-${J()}`, e = L("ComboboxInput"), O = b(() => Te(m(e.inputRef))), d = { value: !1 };
  o({ el: e.inputRef, $el: e.inputRef });
  function s() {
    e.change(null);
    let n = m(e.optionsRef);
    n && (n.scrollTop = 0), e.goToOption($.Nothing);
  }
  let r = b(() => {
    var n;
    let g = e.value.value;
    return m(e.inputRef) ? typeof t.displayValue < "u" && g !== void 0 ? (n = t.displayValue(g)) != null ? n : "" : typeof g == "string" ? g : "" : "";
  });
  X(() => {
    H([r, e.comboboxState, O], ([n, g], [R, a]) => {
      if (d.value) return;
      let x = m(e.inputRef);
      x && ((a === 0 && g === 1 || n !== R) && (x.value = n), requestAnimationFrame(() => {
        var l;
        if (d.value || !x || ((l = O.value) == null ? void 0 : l.activeElement) !== x) return;
        let { selectionStart: u, selectionEnd: v } = x;
        Math.abs((v ?? 0) - (u ?? 0)) === 0 && u === 0 && x.setSelectionRange(x.value.length, x.value.length);
      }));
    }, { immediate: !0 }), H([e.comboboxState], ([n], [g]) => {
      if (n === 0 && g === 1) {
        if (d.value) return;
        let R = m(e.inputRef);
        if (!R) return;
        let a = R.value, { selectionStart: x, selectionEnd: l, selectionDirection: u } = R;
        R.value = "", R.value = a, u !== null ? R.setSelectionRange(x, l, u) : R.setSelectionRange(x, l);
      }
    });
  });
  let T = E(!1);
  function w() {
    T.value = !0;
  }
  function V() {
    le().nextFrame(() => {
      T.value = !1;
    });
  }
  let B = ce();
  function K(n) {
    switch (d.value = !0, B(() => {
      d.value = !1;
    }), n.key) {
      case A.Enter:
        if (d.value = !1, e.comboboxState.value !== 0 || T.value) return;
        if (n.preventDefault(), n.stopPropagation(), e.activeOptionIndex.value === null) {
          e.closeCombobox();
          return;
        }
        e.selectActiveOption(), e.mode.value === 0 && e.closeCombobox();
        break;
      case A.ArrowDown:
        return d.value = !1, n.preventDefault(), n.stopPropagation(), _(e.comboboxState.value, { 0: () => e.goToOption($.Next), 1: () => e.openCombobox() });
      case A.ArrowUp:
        return d.value = !1, n.preventDefault(), n.stopPropagation(), _(e.comboboxState.value, { 0: () => e.goToOption($.Previous), 1: () => {
          e.openCombobox(), N(() => {
            e.value.value || e.goToOption($.Last);
          });
        } });
      case A.Home:
        if (n.shiftKey) break;
        return d.value = !1, n.preventDefault(), n.stopPropagation(), e.goToOption($.First);
      case A.PageUp:
        return d.value = !1, n.preventDefault(), n.stopPropagation(), e.goToOption($.First);
      case A.End:
        if (n.shiftKey) break;
        return d.value = !1, n.preventDefault(), n.stopPropagation(), e.goToOption($.Last);
      case A.PageDown:
        return d.value = !1, n.preventDefault(), n.stopPropagation(), e.goToOption($.Last);
      case A.Escape:
        if (d.value = !1, e.comboboxState.value !== 0) return;
        n.preventDefault(), e.optionsRef.value && !e.optionsPropsRef.value.static && n.stopPropagation(), e.nullable.value && e.mode.value === 0 && e.value.value === null && s(), e.closeCombobox();
        break;
      case A.Tab:
        if (d.value = !1, e.comboboxState.value !== 0) return;
        e.mode.value === 0 && e.activationTrigger.value !== 1 && e.selectActiveOption(), e.closeCombobox();
        break;
    }
  }
  function M(n) {
    h("change", n), e.nullable.value && e.mode.value === 0 && n.target.value === "" && s(), e.openCombobox();
  }
  function p(n) {
    var g, R, a;
    let x = (g = n.relatedTarget) != null ? g : ee.find((l) => l !== n.currentTarget);
    if (d.value = !1, !((R = m(e.optionsRef)) != null && R.contains(x)) && !((a = m(e.buttonRef)) != null && a.contains(x)) && e.comboboxState.value === 0) return n.preventDefault(), e.mode.value === 0 && (e.nullable.value && e.value.value === null ? s() : e.activationTrigger.value !== 1 && e.selectActiveOption()), e.closeCombobox();
  }
  function I(n) {
    var g, R, a;
    let x = (g = n.relatedTarget) != null ? g : ee.find((l) => l !== n.currentTarget);
    (R = m(e.buttonRef)) != null && R.contains(x) || (a = m(e.optionsRef)) != null && a.contains(x) || e.disabled.value || e.immediate.value && e.comboboxState.value !== 0 && (e.openCombobox(), le().nextFrame(() => {
      e.setActivationTrigger(1);
    }));
  }
  let F = b(() => {
    var n, g, R, a;
    return (a = (R = (g = t.defaultValue) != null ? g : e.defaultValue.value !== void 0 ? (n = t.displayValue) == null ? void 0 : n.call(t, e.defaultValue.value) : null) != null ? R : e.defaultValue.value) != null ? a : "";
  });
  return () => {
    var n, g, R, a, x, l, u;
    let v = { open: e.comboboxState.value === 0 }, { displayValue: f, onChange: y, ...C } = t, D = { "aria-controls": (n = e.optionsRef.value) == null ? void 0 : n.id, "aria-expanded": e.comboboxState.value === 0, "aria-activedescendant": e.activeOptionIndex.value === null ? void 0 : e.virtual.value ? (g = e.options.value.find((U) => !e.virtual.value.disabled(U.dataRef.value) && e.compare(U.dataRef.value, e.virtual.value.options[e.activeOptionIndex.value]))) == null ? void 0 : g.id : (R = e.options.value[e.activeOptionIndex.value]) == null ? void 0 : R.id, "aria-labelledby": (l = (a = m(e.labelRef)) == null ? void 0 : a.id) != null ? l : (x = m(e.buttonRef)) == null ? void 0 : x.id, "aria-autocomplete": "list", id: i, onCompositionstart: w, onCompositionend: V, onKeydown: K, onInput: M, onFocus: I, onBlur: p, role: "combobox", type: (u = c.type) != null ? u : "text", tabIndex: 0, ref: e.inputRef, defaultValue: F.value, disabled: e.disabled.value === !0 ? !0 : void 0 };
    return q({ ourProps: D, theirProps: C, slot: v, attrs: c, slots: P, features: Q.RenderStrategy | Q.Static, name: "ComboboxInput" });
  };
} }), nt = j({ name: "ComboboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, hold: { type: [Boolean], default: !1 } }, setup(t, { attrs: h, slots: c, expose: P }) {
  let o = L("ComboboxOptions"), S = `headlessui-combobox-options-${J()}`;
  P({ el: o.optionsRef, $el: o.optionsRef }), Y(() => {
    o.optionsPropsRef.value.static = t.static;
  }), Y(() => {
    o.optionsPropsRef.value.hold = t.hold;
  });
  let i = Ie(), e = b(() => i !== null ? (i.value & G.Open) === G.Open : o.comboboxState.value === 0);
  ge({ container: b(() => m(o.optionsRef)), enabled: b(() => o.comboboxState.value === 0), accept(d) {
    return d.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : d.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(d) {
    d.setAttribute("role", "none");
  } });
  function O(d) {
    d.preventDefault();
  }
  return () => {
    var d, s, r;
    let T = { open: o.comboboxState.value === 0 }, w = { "aria-labelledby": (r = (d = m(o.labelRef)) == null ? void 0 : d.id) != null ? r : (s = m(o.buttonRef)) == null ? void 0 : s.id, id: S, ref: o.optionsRef, role: "listbox", "aria-multiselectable": o.mode.value === 1 ? !0 : void 0, onMousedown: O }, V = Z(t, ["hold"]);
    return q({ ourProps: w, theirProps: V, slot: T, attrs: h, slots: o.virtual.value && o.comboboxState.value === 0 ? { ...c, default: () => [W(Fe, {}, c.default)] } : c, features: Q.RenderStrategy | Q.Static, visible: e.value, name: "ComboboxOptions" });
  };
} }), it = j({ name: "ComboboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, order: { type: [Number], default: null } }, setup(t, { slots: h, attrs: c, expose: P }) {
  let o = L("ComboboxOption"), S = `headlessui-combobox-option-${J()}`, i = E(null), e = b(() => t.disabled);
  P({ el: i, $el: i });
  let O = b(() => {
    var p;
    return o.virtual.value ? o.activeOptionIndex.value === o.calculateIndex(t.value) : o.activeOptionIndex.value === null ? !1 : ((p = o.options.value[o.activeOptionIndex.value]) == null ? void 0 : p.id) === S;
  }), d = b(() => o.isSelected(t.value)), s = ae(ne, null), r = b(() => ({ disabled: t.disabled, value: t.value, domRef: i, order: b(() => t.order) }));
  X(() => o.registerOption(S, r)), ve(() => o.unregisterOption(S, O.value)), Y(() => {
    let p = m(i);
    p && s?.value.measureElement(p);
  }), Y(() => {
    o.comboboxState.value === 0 && O.value && (o.virtual.value || o.activationTrigger.value !== 0 && N(() => {
      var p, I;
      return (I = (p = m(i)) == null ? void 0 : p.scrollIntoView) == null ? void 0 : I.call(p, { block: "nearest" });
    }));
  });
  function T(p) {
    p.preventDefault(), p.button === ye.Left && (e.value || (o.selectOption(S), $e() || requestAnimationFrame(() => {
      var I;
      return (I = m(o.inputRef)) == null ? void 0 : I.focus({ preventScroll: !0 });
    }), o.mode.value === 0 && o.closeCombobox()));
  }
  function w() {
    var p;
    if (t.disabled || (p = o.virtual.value) != null && p.disabled(t.value)) return o.goToOption($.Nothing);
    let I = o.calculateIndex(t.value);
    o.goToOption($.Specific, I);
  }
  let V = xe();
  function B(p) {
    V.update(p);
  }
  function K(p) {
    var I;
    if (!V.wasMoved(p) || t.disabled || (I = o.virtual.value) != null && I.disabled(t.value) || O.value) return;
    let F = o.calculateIndex(t.value);
    o.goToOption($.Specific, F, 0);
  }
  function M(p) {
    var I;
    V.wasMoved(p) && (t.disabled || (I = o.virtual.value) != null && I.disabled(t.value) || O.value && (o.optionsPropsRef.value.hold || o.goToOption($.Nothing)));
  }
  return () => {
    let { disabled: p } = t, I = { active: O.value, selected: d.value, disabled: p }, F = { id: S, ref: i, role: "option", tabIndex: p === !0 ? void 0 : -1, "aria-disabled": p === !0 ? !0 : void 0, "aria-selected": d.value, disabled: void 0, onMousedown: T, onFocus: w, onPointerenter: B, onMouseenter: B, onPointermove: K, onMousemove: K, onPointerleave: M, onMouseleave: M }, n = Z(t, ["order", "value"]);
    return q({ ourProps: F, theirProps: n, slot: I, attrs: c, slots: h, name: "ComboboxOption" });
  };
} });
export {
  ot as Combobox,
  at as ComboboxButton,
  ut as ComboboxInput,
  it as ComboboxOption,
  nt as ComboboxOptions
};
